import AccrualRulesCell from './AccrualRulesCell'
import PtoRulesMixin from './PtoRulesMixin'

class PtoAccrualRulesCell extends AccrualRulesCell {
    constructor() {
        super()

        this.mixin = new PtoRulesMixin()
    }
}

export default PtoAccrualRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PtoAccrualRulesCell.js